import { createSelector } from 'reselect';

const selectHome = state => state.home;

export const getAssistanceList = () => createSelector(selectHome, x => x.assistanceList);
